/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Sets_TodayInputs */

const en_us2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 set today`);
	return /** @type {LocalizedString} */ (`${i?.count} sets today`)
	
};

const pt_br2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série hoje`);
	return /** @type {LocalizedString} */ (`${i?.count} séries hoje`)
	
};

const es_419_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie hoy`);
	return /** @type {LocalizedString} */ (`${i?.count} series hoy`)
	
};

const pt_pt2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série hoje`);
	return /** @type {LocalizedString} */ (`${i?.count} séries hoje`)
	
};

const fr_fr2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série aujourd'hui`);
	return /** @type {LocalizedString} */ (`${i?.count} séries aujourd'hui`)
	
};

const de_de2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz heute`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze heute`)
	
};

const it_it2_workout_sets_today = /** @type {(inputs: Workout_Sets_TodayInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie oggi`);
	return /** @type {LocalizedString} */ (`${i?.count} serie oggi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 set today" |
* | * | "{count} sets today" |
*
* @param {Workout_Sets_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sets_today = /** @type {((inputs: Workout_Sets_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sets_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sets_today(inputs)
	if (locale === "es-419") return es_419_workout_sets_today(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sets_today(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sets_today(inputs)
	if (locale === "de-DE") return de_de2_workout_sets_today(inputs)
	if (locale === "it-IT") return it_it2_workout_sets_today(inputs)
	return en_us2_workout_sets_today(inputs)
});
export { workout_sets_today as "workout.sets_today" }